const en = {};

export { en };
